const events = {
    AT_STATUS_CHANGED: 'AT_STATUS_CHANGED',
    LOGGED_IN: 'logged_in',
    LOGGING_IN: 'logging_in',
    FAILED_LOGIN: 'failed_login',
    LOGGED_OUT: 'logged_out',
    LOGGED_IN_AUTHORIZED: 'logged_in_authorized',
    HTTP_UNAUTHORIZED: 'http_unauthorized',
    STATS:{
        STATUS_LOADED: 'stats.status.loaded',
        STATUS_UPDATED: 'stats.status.updated',
    },
    FILETYPES_LOADED: 'filetypes.loaded',
    FILETYPE_MATCHED: 'filetype.matched',
    FILETYPE_NOT_MATCHED: 'filetype.not.matched',
    BANKING_REPORT_LOADED: 'banking-report.loaded',
    BANKFILE_LOADED: 'bankfile.loaded',
    BANKFILE_MATCHED: 'bankfile.matched',
    EXPORT_LOADED: 'export.loaded',
    EXPORT_UPDATED: 'export.updated',
    EXPORT_DELETED: 'export.deleted',
    TRANSACTION_LOADED: 'transaction.loaded',
    CENTRES_LOADED: 'centres.loaded',
    CENTRE_TRANSACTIONS_LOADED: 'centre-transactions.loaded',
    BANK_TRANSACTIONS_LOADED: 'bank-transactions.loaded',
    TRANSACTIONS_LOADED: 'transactions.loaded',
    TRANSACTIONS_UPDATED: 'transactions.updated',
    CHILD_MATCHES_LOADED: 'child-matches.loaded',
    FISCAL_PERIODS_LOADED: 'fiscal-periods.loaded',
    SIGNALR:{
        CONNECTED: 'signalr.connected',
        DISCONNECTED: 'signalr.disconnected',
        BANKFILE_DATA_CHANGES: 'centre-banking.bank-file.updated',
        BANKFILE_DATA_DELETE: 'centre-banking.bank-file.deleted',
        TRANSACTION_DATA_CHANGES: 'centre-banking.transaction.updated',
        TRANSACTION_DATA_DELETE: 'centre-banking.transaction.delete',
        TRANSACTION_SPLIT_DATA_CHANGES: 'centre-banking.transaction-split.updated',
        TRANSACTION_SPLIT_DATA_CHANGES_DELETE: 'centre-banking.transaction-split.deleted',
        CENTRE_TRANSACTION_DATA_CHANGES: 'centre-banking.centre-transaction.updated',
        CENTRE_TRANSACTION_DATA_CREATED: 'centre-banking.centre-transaction.created',
        CENTRE_TRANSACTION_DATA_DELETE: 'centre-banking.centre-transaction.deleted',
        TRANSACTION_BULK_MATCHED: 'centre-banking.transaction.bulk-matched',
        EXPORT_DATA_CHANGES: 'centre-banking.export-batch.created',
        EXPORT_DELETED: 'centre-banking.export-batch.deleted',
        CHILD_MATCH_CREATED: 'centre-banking.child-match.created',
        CHILD_MATCH_UPDATED: 'centre-banking.child-match.updated',
        CHILD_MATCH_DELETED: 'centre-banking.child-match.deleted',
        CENTRE_DATA_SYNC: 'centre-banking.centre-data.sync',
        CENTRE_BANKING_MERCHANT_FILE_UPLOADED: 'centre-banking.merchantfile.uploaded',
        FISCAL_PERIODS_UPDATED: 'finance.fiscalperiods.updated'
    }
};

export default events;